export default __webpack_public_path__ + "static/media/pin.e89382ca.svg";